module.exports = __webpack_public_path__ + "VU.png?61e90ff07b87c6aff4cba5febff60719";